export enum ActiveProfileDataTab {
  General = "general",
  SocialData = "social-data",
  Activity = "activity",
  Performance = "performance",
}
